const KEY = 'mx_recent_templates_v1';
const MAX = 8;

function read(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

function write(ids: string[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids));
  } catch {
    /* localStorage may be disabled */
  }
}

export function recordTemplateUse(id: string): void {
  if (!id) return;
  const next = [id, ...read().filter((x) => x !== id)].slice(0, MAX);
  write(next);
}

export function getRecentTemplateIds(): string[] {
  return read();
}

export function clearRecentTemplates(): void {
  write([]);
}
